import Column from "./column/index.js";
import Home from "./home/index.js";
import Staff from "./staff/index.js";
import Assessment from "./assessment/index.js";
import Member from "./member/index.js";
import Company from "./company/index.js";
import EstateIndex from "./estate/index.js";
import EstateDetail from "./estate/detail.js";
import FpConsultation from "./fp-consultation/index.js";
import Contact from "./contact/index.js";
import SearchArea from "./search/area.js";
import SearchStation from "./search/station.js";
import SearchSchool from "./search/school.js";

const pages = () => {
    Column();
    Home();
    Staff();
    Home();
    Assessment();
    Company()
    Member()
    EstateIndex();
    EstateDetail();
    FpConsultation();
    Contact()
    SearchArea();
    SearchStation();
    SearchSchool();
}

export default pages;
